// extracted by mini-css-extract-plugin
export default {"triangleDown":"Pricing_triangleDown__lq-QW","Header":"Pricing_Header__pUBzb"};